<script setup>
import SiteMenu from '@/components/SiteMobileMenu.vue';

import { useRouting } from "@/composables/routing";
const { page, href } = useRouting();

const login = () => {
    window.location = page.props.loginUrl;
}

const register = () => {
    window.location = page.props.registrationUrl;
}

const mobileMenu = ref(null);
import { Link } from '@inertiajs/vue3'

import { router } from '@inertiajs/vue3'
router.on('before', () => {
    mobileMenu.value = false;
})

import {useI18n} from "vue-i18n";
import DesktopMainMenu from "@/components/DesktopMainMenu/DesktopMainMenu.vue";
const { t } = useI18n();

const visible = ref(false);
const items = ref([
    {
        label: t("Solutions"),
        root: true,
        items: [
            [
                {
                    items: [
                        { label: 'Features', icon: 'pi pi-list', subtext: 'Subtext of item' },
                        { label: 'Customers', icon: 'pi pi-users', subtext: 'Subtext of item' },
                        { label: 'Case Studies', icon: 'pi pi-file', subtext: 'Subtext of item' }
                    ]
                }
            ],
            [
                {
                    items: [
                        { label: 'Solutions', icon: 'pi pi-shield', subtext: 'Subtext of item' },
                        { label: 'Faq', icon: 'pi pi-question', subtext: 'Subtext of item' },
                        { label: 'Library', icon: 'pi pi-search', subtext: 'Subtext of item' }
                    ]
                }
            ],
            [
                {
                    items: [
                        { label: 'Community', icon: 'pi pi-comments', subtext: 'Subtext of item' },
                        { label: 'Rewards', icon: 'pi pi-star', subtext: 'Subtext of item' },
                        { label: 'Investors', icon: 'pi pi-globe', subtext: 'Subtext of item' }
                    ]
                }
            ],
            [
                {
                    items: [{ image: 'https://primefaces.org/cdn/primevue/images/uikit/uikit-system.png', label: 'GET STARTED', subtext: 'Build spectacular apps in no time.' }]
                }
            ]
        ]
    },
    {
        label: 'Resources',
        root: true
    },
    {
        label: 'Contact',
        root: true
    }
]);

const onHover = (e, item) => {
    console.log(e, item);
}
</script>

<template>
    <header class="relative">
        <site-menu v-model="mobileMenu" />

        <div class="container mx-auto px-4 flex items-center justify-center gap-6 md:justify-between min-h-[8rem] md:min-h-[10rem]">
            <button class="md:hidden focus:outline-none absolute left-5"
                    @click="mobileMenu = true"
            >
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>
            </button>

            <Link class="text-lg font-bold mr-8 no-underline"
                  :href="href('/')"
            >
                <img src="/assets/logo-500-100.png" alt="LAY7 cloud" class="h-auto w-full max-w-[250px] ml-12 md:ml-0">
            </Link>

<!--            <desktop-main-menu />-->

            <nav class="hidden md:flex space-x-9 xl:space-x-20 text-lg font-bold">
                <Link :href="href('/solutions')" class="hover:text-gray-900">{{ $t("Solutions") }}</Link>
                <Link :href="href('/features')" class="hover:text-gray-900">{{ $t("Features") }}</Link>
                <Link :href="href('/pricing')" class="hover:text-gray-900">{{ $t("Pricing") }}</Link>
            </nav>

            <div class="hidden md:flex space-x-4">
                <div class="hidden lg:flex">
                    <Button severity="secondary"
                            variant="outlined"
                            size="large"
                            @click="login"
                    >
                        Login
                    </Button>
                </div>

                <Button class="px-12 lg:px-12 py-12 bg-black text-white text-lg font-bold"
                        size="large"
                        as="a"
                        @click="register"
                        :label="$t('Create account')"
                ></Button>
            </div>
        </div>
    </header>
</template>
